import { IPlot } from "@interfaces/IPlot";
import { CameraCommunicationServer, IDeviceInfo } from "@services/cameraCommunicationServer.service";
import "./cameraDeviceInfo.component.scss";


export class CameraDeviceInfoComponentController implements angular.IComponentController  {

    cameraSerial: string;
    deviceInfo: IDeviceInfo;
    onDataLoaded: (args: { deviceInfo: IDeviceInfo }) => void;

    devicePlot: IPlot;

    static $inject = ["cameraCommunicationServer"];

    constructor(private cameraCommunicationServer: CameraCommunicationServer) {

    }
    
    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.loadData();
    }

    loadData() {
        console.log("loadData", this.cameraSerial);
        if (this.cameraSerial?.length) {
            this.cameraCommunicationServer.getDeviceInfo(this.cameraSerial).then(deviceInfo => {
                this.deviceInfo = deviceInfo;

                if (this.onDataLoaded) {
                    this.onDataLoaded({ deviceInfo: this.deviceInfo });
                }

                this.devicePlot = {
                    Direction: this.deviceInfo.Heading,
                    Velocity: this.deviceInfo.Speed,
                    Latitude: this.deviceInfo.Lat,
                    Longitude: this.deviceInfo.Lon
                }
            });
        } else {
            this.deviceInfo = null;
        }
    }
}

export class CameraDeviceInfoComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            cameraSerial: "<",
            onDataLoaded: "&"
        };

        this.controller = CameraDeviceInfoComponentController;
        this.template = require("./cameraDeviceInfo.component.html");
    }
}
